import type { FC } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Box, Button, Stack } from "@mui/material";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { useReportUserMutation } from "store/current-user/current-user.api";

export const ReportUserMenu: FC = () => {
  const { reportUserMenu } = useShallowPickSelector("app", ["reportUserMenu"]);
  const { user, auth } = useShallowPickSelector("currentUser", [
    "user",
    "auth",
  ]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  const [reportUser] = useReportUserMutation();

  const onClose = () => {
    dispatch(appActions.setReportUserMenu({ isOpen: false, userId: null }));
  };

  const onClickReason = (reason: string) => {
    if (reportUserMenu.userId) {
      reportUser({ userId: reportUserMenu.userId, reason });
      dispatch(appActions.setReportUserDoneMenu({ isOpen: true }));
      onClose();
    }
  };

  return (
    <BottomSheet
      title={"گزارش کاربر"}
      isOpen={reportUserMenu.isOpen}
      onClose={onClose}
    >
      <Stack
        sx={{
          "& .MuiButton-text": {
            direction: "rtl",
            textAlign: "right",
            justifyContent: "flex-start",
            color: "rgba(255,255,255,0.6)",
            px: 3,
            borderRadius: 0,
          },
        }}
      >
        {[
          "این کاربر وانمود می‌کند شخص دیگری است",
          "این کاربر از عکس‌های من استفاده می‌کند",
          "این کاربر اسپم ارسال می‌کند",
          "این کاربر مطالب غیراخلاقی به اشتراک می‌گذارد",
        ].map((reason, index) => (
          <Box key={index}>
            {index !== 0 && (
              <Box
                sx={{
                  mx: 3,
                  borderTop: "2px solid rgba(255,255,255,0.05)",
                }}
              />
            )}
            <Button
              color={"secondary"}
              fullWidth
              onClick={() => onClickReason(reason)}
            >
              {reason}
            </Button>
          </Box>
        ))}
      </Stack>
    </BottomSheet>
  );
};
